export enum SpinnerOverlayStatusEnum {
    CLOSED = "closed",
    CLOSING = "closing",
    OPENED = "opened",
    OPENING = "opening",
}

export type SpinnerOverlayTransitionStatusType =
    | string
    | SpinnerOverlayStatusEnum.CLOSED
    | SpinnerOverlayStatusEnum.CLOSING
    | SpinnerOverlayStatusEnum.OPENED
    | SpinnerOverlayStatusEnum.OPENING;
